import React from 'react'

class NotificationsSection extends React.Component {
  state = {}

  componentDidMount () {}

  render () {
    var content = <div>Notifications section</div>

    return content
  }
}

module.exports = NotificationsSection
